export const calculateRunningTotal = (
  entries: readonly number[],
  index = 0,
  sum = 0
): number[] => {
  if (index >= entries.length) {
    return [];
  }

  const currentSum = sum + (entries[index] ?? 0);
  const runningTotal = calculateRunningTotal(entries, index + 1, currentSum);
  return [currentSum, ...runningTotal];
};
